/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { action, computed, get } from '@ember/object';

@tagName('')
export default class ItemPickerDialog extends Component {
  @action
  setSearch(value) {
    this.search = value;
  }

  // Required
  title = '';

  placeholder = '';
  items = null;
  selectedIds = null;
  onToggle = null;
  onCancel = null;
  onConfirm = null;

  // Optional: when set, items are grouped by this field with a heading per group
  @tracked groupByField = null;

  // Internal
  @tracked search = '';

  @computed('items.[]', 'search')
  get filteredItems() {
    let items = this.items || [];
    let search = (this.search || '').toLowerCase().trim();
    if (!search) return items;
    return items.filter((item) =>
      (get(item, 'label') || '').toLowerCase().includes(search),
    );
  }

  @computed('filteredItems.[]', 'groupByField')
  get groupedItems() {
    let groupByField = this.groupByField;
    if (!groupByField) return null;
    let groups = new Map();
    for (let item of this.filteredItems || []) {
      let heading = get(item, groupByField) || '';
      if (!groups.has(heading)) groups.set(heading, []);
      groups.get(heading).push(item);
    }
    return Array.from(groups, ([heading, items]) => ({ heading, items }));
  }
}
